import React from "react"

import { parse } from "node-html-parser"

import ComponentFactory from "./parsers/ComponentFactory"

import * as courseSection from "../styles/CourseSection.module.css"

export default function CourseSection(props) {
  const { content } = props

  const contentWrapperProps = {
    className: "course-section",
  }

  const components = ComponentFactory(content.innerHTML, contentWrapperProps)

  // const firstChild = (components.props.children && components.props.children[0]) || <></>
  const secondChild = (components.props.children &&
    components.props.children[1]) || <></>

  return (
    <div className={`row ${courseSection.wrapper}`}>
      {/* <div className={`col-6 ${courseSection.intro}`}>
        <div>{firstChild}</div>
      </div> */}
      <div className={`col-12 ${courseSection.intro}`}>
        <div>{secondChild}</div>
      </div>
    </div>
  )
}
